import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import * as moment from 'moment';

import { deepEqual } from '../utils';
import lifeEventsTypes from './lifeEvents.types';

import Duration from '../Shared/DateTime/Duration';

class LifeEventRow extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  getEventName() {
    const { eventType } = this.props.event;

    switch (eventType) {
      case lifeEventsTypes.WORK:
        return 'Trabalho';
      case lifeEventsTypes.WEEKLY_REST:
        return 'Descanso Semanal';
      case lifeEventsTypes.ABSENCE:
        return 'Falta';
      case lifeEventsTypes.EXEMPTION:
        return 'Dispensado do Trabalho';
      case lifeEventsTypes.MEDICAL_LEAVE:
        return 'Afastamento';
      case lifeEventsTypes.MEDICAL_REST:
        return 'Atestado Médico';
      case lifeEventsTypes.VACATION:
        return 'Férias';
      default:
        return 'NÃO DEFINIDO';
    }
  }

  render() {
    const { event, isLast } = this.props;

    const duration = isLast ? (moment().valueOf() - event.startedAt) : (event.duration || 0);

    return (
      <tr>
        <td><Moment format="DD/MM/YYYY HH:mm:ss">{event.startedAt}</Moment></td>
        <td>
          {this.getEventName()}
          {event.eventType === lifeEventsTypes.WEEKLY_REST &&
            <span>{event.eventMetaHoursSize}h</span>}
        </td>
        <td className="align-right"><Duration ms={duration} as="days" /></td>
        <td className="align-right"><Duration ms={event.accWork || 0} as="days" /></td>
        <td className="align-right"><Duration ms={event.accWeeklyRest || 0} as="days" /></td>
      </tr>
    );
  }
}

LifeEventRow.propTypes = {
  event: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
};

LifeEventRow.defaultProps = {
  isLast: false,
};

export default LifeEventRow;



// WEBPACK FOOTER //
// ./src/Driver/LifeEventRow.js